import { getLocationInfos } from '@/helpers/GeoLocation/GeoLocationHelper';
import { HgSupportedLanguage } from '@smg-real-estate/domus/types';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import { useLocalLandingStore } from '@/stores/localLanding/localLanding';
import { storeToRefs } from 'pinia';

export function usePageTitle() {
  const { t, locale } = useI18n();
  const localLandingStore = useLocalLandingStore();
  const { propertyType, routeGeoLocation } = storeToRefs(localLandingStore);

  const routeLocationName = computed((): string => {
    return getLocationInfos(routeGeoLocation.value, locale.value as HgSupportedLanguage).name;
  });

  const pageTitle = computed<string>(() => {
    return t(`localLanding.hero.title.${propertyType.value}`, {
      location: routeLocationName.value,
    });
  });

  const description = computed<string>(() => {
    return t('localLanding.hero.description', {
      location: routeLocationName.value,
    });
  });

  return {
    pageTitle,
    description,
  };
}
